const API_PREFIX = "/marketing/lists";

export const getMarketingListsEndpoint = () => API_PREFIX;
export const createMarketingListEndpoint = () => API_PREFIX;
export const getMarketingListEndpoint = (id: string) => `${API_PREFIX}/${id}`;
export const updateMarketingListEndpoint = (id: string) => `${API_PREFIX}/${id}`;
export const deleteMarketingListEndpoint = (id: string) => `${API_PREFIX}/${id}`;

export const getMarketingListMembersEndpoint = (id: string) => `${API_PREFIX}/${id}/members`;
export const getMarketingAvailableClientsEndpoint = (id: string) => `${API_PREFIX}/${id}/available-clients`;
export const addMarketingListClientsEndpoint = (id: string) => `${API_PREFIX}/${id}/members/clients`;
export const addMarketingListContactEndpoint = (id: string) => `${API_PREFIX}/${id}/members/contact`;
export const bulkRemoveMarketingListMembersEndpoint = (id: string) => `${API_PREFIX}/${id}/members/bulk-remove`;
export const removeMarketingListMemberEndpoint = (id: string, memberId: string) =>
  `${API_PREFIX}/${id}/members/${memberId}`;

export const getMarketingListRecipientsEndpoint = (id: string) => `${API_PREFIX}/${id}/recipients`;

export const marketingCsvTemplateEndpoint = () => `${API_PREFIX}/csv-template`;
export const validateMarketingCsvEndpoint = (id: string) => `${API_PREFIX}/${id}/import/validate`;
export const commitMarketingCsvEndpoint = (id: string) => `${API_PREFIX}/${id}/import/commit`;
export const marketingImportHistoryEndpoint = (id: string) => `${API_PREFIX}/${id}/import/history`;
